import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from "@ant-design/icons"


export default function ModalAlerta({
  open,
  onClose,
  tipoAlerta,
  mensaje
}) {

  // console.log("lo que llega", tipoAlerta)

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      {tipoAlerta === "exito" && (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <CheckCircleOutlined style={{ fontSize: 60, marginBottom: 10, color: "#0aa937" }} />
          <h2 style={{ color: "green" }}>¡Operación exitosa!</h2>
          <p>{mensaje || "Tu mensaje fue enviado correctamente."}</p>
        </div>
      )}
      {tipoAlerta === "errorCaptcha" && (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <WarningOutlined style={{ fontSize: 60, marginBottom: 10, color: "orange" }}/>
          <h2 style={{ color: "orange" }}>Error de verificación</h2>
          <p>{mensaje || "Por favor, completá el captcha correctamente."}</p>
        </div>
      )}
      {tipoAlerta === "error" && (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <CloseCircleOutlined style={{ fontSize: 60, marginBottom: 10, color: "rgb(186, 23, 33)" }}/>
          <h2 style={{ color: "red" }}>¡Ocurrió un error!</h2>
          <p>{mensaje || "No pudimos completar la operación."}</p>
        </div>
      )}
    </Modal>
  )
}